/** @jsxImportSource theme-ui */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router';
import { Container } from 'semantic-ui-react';

import { useInsightsRouting } from 'hooks/useInsightsRouting';
import { isUserAdmin } from 'utils/authHelpers';

import { Typography } from 'components/_common/Typography';

import * as UserSelectors from 'user/user.selectors';

import SettingsFooter from '../SettingsView/_common/SettingsFooter';
import SettingsLoader from '../SettingsView/_common/SettingsLoader';
import { DiseaseGroup } from './DiseaseGroup';
import { RoleDiseaseRelevance } from './RoleDiseaseRelevance';
import { UserAdmin } from './UserAdmin';
import { UserEmailTypes } from './UserEmailTypes';
import { UserGroupAdmin } from './UserGroupAdmin';
import { UserTypeAdmin } from './UserTypeAdmin';

const SettingsView: React.FC = () => {
  const { navigateToDefault } = useInsightsRouting();
  const userProfile = useSelector(UserSelectors.userProfileSelector);

  useEffect(() => {
    if (userProfile && !isUserAdmin(userProfile)) navigateToDefault();
  }, [userProfile]);

  return (
    <div
      sx={{
        position: 'relative',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
      }}
    >
      <SettingsLoader />
      <Container
        fluid
        sx={{
          '&.ui.container': {
            px: '20px',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 'calc(100vh - 44px)', // CODE: b31008c1
          },
        }}
      >
        <div sx={{ flexGrow: 1, position: 'relative' }}>
          <div
            sx={{
              mt: ['20px', '50px'],
              mb: '30px',
              textAlign: ['left', 'center'],
            }}
          >
            <Typography variant="h4" color="deepSea100">
              Admin Settings
            </Typography>
          </div>

          <Routes>
            <Route path="usertypes" element={<UserTypeAdmin />} />
            <Route path="usergroups" element={<UserGroupAdmin />} />
            <Route path="useradmin" element={<UserAdmin />} />
            <Route path="diseasegroup" element={<DiseaseGroup />} />
            <Route path="rolediseaserelevance" element={<RoleDiseaseRelevance />} />
            <Route path="useremailtypes" element={<UserEmailTypes />} />
          </Routes>
        </div>

        <SettingsFooter />
      </Container>
    </div>
  );
};

export default SettingsView;
